// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"About_visuallyHidden__uR3Tv","content":"About_content__aHwTY","image":"About_image__EorJG","info":"About_info__feAL+","info__list":"About_info__list__kMl1b"};